var React = require('react');

function TumbleM (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Desktop---Phase-1","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd"},React.createElement("g",{"id":"Ikoner/Tumble-dry-Medium-temp","transform":"translate(-2.471 -1.842)"},[React.createElement("circle",{"id":"Oval-11","stroke":"#000","strokeWidth":"2","cx":"20","cy":"20","r":"14.5","key":0}),React.createElement("circle",{"id":"Oval-11","fill":"#000","fillRule":"evenodd","cx":"16.5","cy":"20","r":"2","key":1}),React.createElement("circle",{"id":"Oval-11","fill":"#000","fillRule":"evenodd","cx":"23.5","cy":"20","r":"2","key":2}),React.createElement("path",{"id":"Rectangle-21","stroke":"#000","strokeWidth":"2","d":"M3.557 3.557h32.886v32.886H3.557z","key":3})])));
}

TumbleM.defaultProps = {"width":"35","height":"36","viewBox":"0 0 35 36"};

module.exports = TumbleM;

TumbleM.default = TumbleM;
